import { AkaCriticalIllnessProduct } from "Store/interfaces/products/checkout/lifeProducts/AkaCriticalIllnessProduct";
import { AkaCriticalIllness } from "Store/interfaces/products/coverage";
import { ProductDetail } from "../../interface";

export const akaCriticalIllnessDetailsList = (
  product: AkaCriticalIllnessProduct,
  types: any,
): ProductDetail[] => [
  {
    name: "coverageAmountMember",
    value: `${product.memberApplicantInsuranceSpecification?.coverageAmountGLevel} ${types.coverageGLevel}`,
    hidden:
      product.coverageGroup !== AkaCriticalIllness.AKA_CRITICAL_ILLNESS &&
      product.coverageGroup !==
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS_MEMBER_AND_CO_INSURED,
  },
  {
    name: "coverageAmountCoInsured",
    value: `${product.coInsuredApplicantInsuranceSpecification?.coverageAmountGLevel} ${types.coverageGLevel}`,
    hidden:
      product.coverageGroup !==
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS_CO_INSURED &&
      product.coverageGroup !==
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS_MEMBER_AND_CO_INSURED,
  },
];
